/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Account Status
 * @export
 */
export const AccountStatus = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    AwaitingApproval: 'awaiting_approval'
} as const;
export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];


export function instanceOfAccountStatus(value: any): boolean {
    for (const key in AccountStatus) {
        if (Object.prototype.hasOwnProperty.call(AccountStatus, key)) {
            if (AccountStatus[key as keyof typeof AccountStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountStatusFromJSON(json: any): AccountStatus {
    return AccountStatusFromJSONTyped(json, false);
}

export function AccountStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountStatus {
    return json as AccountStatus;
}

export function AccountStatusToJSON(value?: AccountStatus | null): any {
    return value as any;
}

